import { f7, View } from "framework7-react";
import { useEffect } from "react";

import { useIsLoggedIn } from "@/hooks/useIsLoggedIn";
import { AppProvider } from "@/providers/AppProvider";
import { AuthProvider } from "@/providers/AuthProvider";

import { AppLayout } from "./AppLayout";

const PUBLIC_ROUTES = ["/sign-in/", "/sign-up/", "/password-reset/"];

function getPublicRouteInfo() {
  if (typeof window === "undefined") {
    return { initialUrl: "/sign-in/", isPublicRoute: false };
  }

  const currentPath = window.location.pathname;
  const isPublicRoute = PUBLIC_ROUTES.some((route) => currentPath.startsWith(route));
  const initialUrl = isPublicRoute ? `${currentPath}${window.location.search}` : "/sign-in/";
  return { initialUrl, isPublicRoute };
}

export function App() {
  return (
    <AppProvider theme="md">
      <AuthProvider>
        <AppMain />
      </AuthProvider>
    </AppProvider>
  );
}

function AppMain() {
  const isLoggedIn = useIsLoggedIn();
  const { initialUrl, isPublicRoute } = getPublicRouteInfo();

  useEffect(() => {
    if (!isLoggedIn && !isPublicRoute) {
      f7.views.main.router.navigate("/sign-in/");
    }
  }, [isLoggedIn, isPublicRoute]);

  if (!isLoggedIn) {
    return (
      <View
        main
        url={initialUrl}
      />
    );
  }

  return <AppLayout />;
}
